import * as React from 'react'
import * as style from './DotNav.module.scss'
import * as cn from 'classnames'

interface DotNavProps {
  moveTo: Function
  size: number
  activeIndex: number
}

const getDots = (size: number, dotClick: Function, activeIdx: number) => Array.from(Array(size).keys()).map(
  (index) => (<li className={activeIdx === index ? style.active : style.inactive}
    onClick={dotClick.bind(null, index)} id={`index-${index}`}><b>{index}</b></li>)
)

const DotNav = (props: DotNavProps) => {
  const handleClick = (index: number) => {
    const animationDuration = 500
    props.moveTo(index, animationDuration)
  }

  return (
    <ul className={cn('tst-superhero-dots', style.dotNav)}>
      {getDots(props.size,
        handleClick,
        props.activeIndex)}
    </ul>
  )
}

export default DotNav
